var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "gonser-box",
      class: [
        _vm.getClasses,
        {
          hide: _vm.setVisibility && !_vm.isBoxItem,
          smaller: _vm.smaller,
          isBasketOverlay: _vm.isBasketOverlay,
        },
      ],
    },
    [
      _vm.hasTotalItems
        ? _c(
            "div",
            {
              staticClass: "gonser-box-inner align-items-center",
              class: { "d-md-flex": !_vm.column },
            },
            [
              _c(
                "div",
                {
                  staticClass: "gonser-box-column-one",
                  class: { "mb-5 mb-md-0": !_vm.column, "mb-4": _vm.column },
                },
                [
                  _c("div", { staticClass: "h3 mb-3" }, [
                    !_vm.isBasketOverlay && _vm.isFree
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxAmountReached"
                              )
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBasketOverlay && _vm.isFree
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxAmountReachedBasketItemOverlay"
                              )
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isFree && _vm.isBasketOverlay
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxAmountLeftBasketItemOverlay",
                                { diff: _vm.getCurrencyString(_vm.diff) }
                              )
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isFree && !_vm.isBasketOverlay
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxAmountLeft",
                                { diff: _vm.getCurrencyString(_vm.diff) }
                              )
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isBasketOverlay
                      ? _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 512 512",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openShippingInfo()
                              },
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex gonser-progress-bar" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "gonser-box-shipping-progress-info position-relative d-flex justify-content-between align-items-center w-100",
                        },
                        [
                          _c("div", {
                            staticClass:
                              "gonser-box-shipping-progress-bar bg-success position-absolute h-100",
                            style:
                              "width: " +
                              ((_vm.total * 100) / _vm.limit).toFixed(0) +
                              "%",
                          }),
                          _vm._v(" "),
                          _c("span", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.getCurrencyString(_vm.total))),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            !_vm.isFree
                              ? _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.getCurrencyString(_vm.diff))
                                  ),
                                ])
                              : _c("i", { staticClass: "fa fa-check fa-lg" }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isBasketOverlay && _vm.isSmallScreen
                        ? _c("lazy-img", {
                            attrs: {
                              "picture-class": "img-fluid",
                              "image-url":
                                "https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/gonserbox.png",
                              alt: "Gonser-Box",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.isBasketOverlay ||
              (_vm.isBasketOverlay && !_vm.isSmallScreen)
                ? _c("div", { staticClass: "gonser-box-column-two" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-sm-flex justify-content-between align-items-center",
                        class: {
                          "justify-content-md-start justify-content-lg-between":
                            _vm.column,
                          "justify-content-md-center": !_vm.column,
                        },
                      },
                      [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxExplanation",
                                { limit: _vm.getCurrencyString(_vm.limit) }
                              )
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "img-wrapper" },
                          [
                            _c("lazy-img", {
                              attrs: {
                                "picture-class": "img-fluid",
                                "image-url":
                                  "https://cdn02.plentymarkets.com/mrt54q44tptl/frontend/gonserbox.png",
                                alt: "Gonser-Box",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showAdditionalInfo
                ? _c("div", { staticClass: "gonser-box-column-three mt-3" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-dark btn-sm d-block d-sm-inline-block mb-3 mb-md-0 mr-sm-3",
                        attrs: {
                          href: _vm.$translate(
                            "GonserDT::Template.themeBoxCategoryUrl"
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxShowAllItems"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isCheckout
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-secondary text-white mb-3 mb-md-0 btn-sm d-block d-sm-inline-block",
                            attrs: {
                              title: _vm.$translate(
                                "Ceres::Template.shippingInfoCosts"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openShippingInfo()
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "GonserDT::Template.generalMoreInfo"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        )
                      : _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-secondary mb-3 mb-md-0 btn-sm d-block d-sm-inline-block",
                            attrs: {
                              href: _vm.$translate(
                                "GonserDT::Template.uspsFeat1URL"
                              ),
                              title: _vm.$translate(
                                "Ceres::Template.shippingInfoCosts"
                              ),
                            },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$translate(
                                    "GonserDT::Template.generalMoreInfo"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.isShopBuilder && _vm.isItem) || (_vm.setVisibility && _vm.isItem)
        ? _c(
            "div",
            {
              staticClass:
                "gonser-box-description row flex-column flex-sm-row no-gutters",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "gonser-box-img col-12 col-sm-4 col-lg-3 align-self-center text-center",
                },
                [
                  _c("lazy-img", {
                    attrs: {
                      "picture-class": "img-fluid",
                      "image-url":
                        "/layout/gonser_2015_20190704/img/gonserbox.png",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "gonser-box-text col-12 col-sm-8 col-lg-9 pl-sm-3",
                },
                [
                  _c("p", {
                    staticClass: "headline font-weight-bolder",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "GonserDT::Template.gonserBoxExplainTitle"
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "GonserDT::Template.gonserBoxExplainText"
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-wrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-dark btn-sm d-block d-sm-inline-block mb-3 mb-md-0 mr-sm-3",
                        attrs: {
                          href: _vm.$translate(
                            "GonserDT::Template.themeBoxCategoryUrl"
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.gonserBoxShowAllItems"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-secondary btn-sm d-block mb-3 mb-md-0 d-sm-inline-block",
                        attrs: {
                          "data-toggle": "modal",
                          href: "#shippingscosts",
                          title: _vm.$translate(
                            "Ceres::Template.shippingInfoCosts"
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.generalMoreInfo"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }